module.exports = __webpack_public_path__ + "img/support.e80c64c5.svg";